import React from 'react';
import { CurrencyDollarIcon, ChartBarIcon, ArrowTrendingUpIcon } from '@heroicons/react/24/outline';
import { useIntl } from 'react-intl';
import numeral from 'numeral';
import { currencySymbol } from '../../../../utils/formatters';

const formatCurrency = (value) => {
  if (value === null || value === undefined) return 'N/A';
  return `${currencySymbol()}${numeral(value).format('0,0')}`;
};

const ValuationSummaryWidget = ({ data, onAction }) => {
  const intl = useIntl();
  const { current_value, annual_revenue, ebitda, growth_rate, dcf_id, link } = data;

  const displayValue = current_value < 0 ? `-${formatCurrency(Math.abs(current_value))}` : formatCurrency(current_value);

  return (
    <div className="bg-succession-bg-primary border border-succession-border rounded-lg p-4 text-succession-text-primary">
      <div className="flex items-center gap-3 mb-4">
        <CurrencyDollarIcon className="w-6 h-6 text-green-500" />
        <h3 className="text-base font-semibold text-succession-text-primary">
          {intl.formatMessage({ id: 'succession.agent_system.valuation_summary_widget.title' })}
        </h3>
      </div>

      <div className="mb-4">
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm text-succession-text-secondary">{intl.formatMessage({ id: 'succession.agent_system.valuation_summary_widget.practice_value' })}</span>
          <span className="text-base font-semibold text-green-500">{displayValue}</span>
        </div>
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm text-succession-text-secondary">{intl.formatMessage({ id: 'succession.agent_system.valuation_summary_widget.annual_revenue' })}</span>
          <span className="text-base font-semibold text-succession-text-primary">{formatCurrency(annual_revenue)}</span>
        </div>
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm text-succession-text-secondary">{intl.formatMessage({ id: 'succession.agent_system.valuation_summary_widget.ebitda' })}</span>
          <span className="text-base font-semibold text-succession-text-primary">{formatCurrency(ebitda)}</span>
        </div>
        {growth_rate !== undefined && growth_rate !== null && (
          <div className="flex justify-between items-center">
            <span className="text-sm text-succession-text-secondary">{intl.formatMessage({ id: 'succession.agent_system.valuation_summary_widget.growth_rate' })}</span>
            <span className={`text-base font-semibold ${growth_rate >= 0 ? 'text-green-500' : 'text-red-500'}`}>
              {numeral(growth_rate).format('0.00%')}
            </span>
          </div>
        )}
      </div>

      <button
        onClick={() => onAction?.({ type: 'view_valuation', url: link || `/succession/valuation?dcf_id=${dcf_id}` })}
        className="w-full px-3 py-2 bg-succession-primary text-white border-none rounded-lg text-sm font-medium cursor-pointer transition-all duration-200 flex items-center justify-center gap-2 hover:bg-succession-primary-hover"
      >
        {intl.formatMessage({ id: 'succession.agent_system.valuation_summary_widget.view_full_report' })}
        <ArrowTrendingUpIcon className="w-4 h-4" />
      </button>
    </div>
  );
};

export default ValuationSummaryWidget;